const FilterClearIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8283 7.41414L4.38384 0.969697H14.2222C14.5589 0.969697 14.8013 1.11785 14.9495 1.41414C15.0976 1.71044 15.0707 1.99327 14.8687 2.26263L10.8283 7.41414ZM14.8485 16L10.1818 11.3333V13.0909C10.1818 13.3199 10.1044 13.5118 9.94949 13.6667C9.79461 13.8215 9.60269 13.899 9.37374 13.899H7.75758C7.52862 13.899 7.3367 13.8215 7.18182 13.6667C7.02694 13.5118 6.94949 13.3199 6.94949 13.0909V8.10101L0 1.15152L1.13131 0L16 14.8687L14.8485 16Z" fill="#101828" />
    </svg>
  );
};

export default FilterClearIcon;
